<div class="photo-preview-wrapper">
  <img
    nz-image
    nzDisablePreview
    class="photo-preview take-photo-wrapper"
    [nzSrc]="effectiveSrc()"
    (load)="onImageLoaded($event)"
  />

  @if (!useDefaultImage()) {
    @for (marker of markers(); track marker.sensorID ?? $index) {
      <div
        class="sensor-marker-wrapper"
        [style.left.px]="
          marker.getClientX(
            clientWidth(),
            clientHeight(),
            imageWidth(),
            imageHeight(),
            30
          )
        "
        [style.top.px]="
          marker.getClientY(
            clientWidth(),
            clientHeight(),
            imageWidth(),
            imageHeight(),
            32
          )
        "
      >
        <div class="sensor-marker" [class.selected]="marker.selected">
          <span [class.smallFont]="marker.label.length > 3">
            {{ marker.label }}
          </span>
          <div class="sub-marker body-bold">
            <span [class.smallFont]="marker.label.length > 3">
              {{ marker.label }}
            </span>
          </div>
        </div>
      </div>
    }
  }
</div>
